
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.4 7c0-1.076.824-1.948 1.84-1.948L18 5l6 6v15.202c0 1.076-.823 1.948-1.838 1.948H8.239c-1.015 0-1.839-.872-1.839-1.948V7z","fill":"#fff"}}),_c('path',{attrs:{"d":"M18 10V5l6 6h-5c-.615 0-1-.385-1-1zM10 15.563C10 14.7 10.7 14 11.563 14h6.874C19.3 14 20 14.7 20 15.563v6.874C20 23.3 19.3 24 18.437 24h-6.875C10.7 24 10 23.3 10 22.437v-6.875z","fill":"#B4BCCF"}}),_c('path',{attrs:{"d":"M11 17h8v5h-8v-5z","fill":"#fff"}}),_c('path',{attrs:{"d":"M19 11l5 4.8V11h-5z","fill":"#525F7F"}})])
          )
        }
      }
    